import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import baoDialog from "./../../../factories/bao-dialog";
import baoRouter from "./../../../services/bao-router";
function EvaluationFilterViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Checklists = ko.observableArray([]);
    self.FolderStructureChecklistId = ko.observable();
    self.EvaluationFilters = ko.observableArray([]);
    self.EvaluationFilterId = ko.observable();
    self.CreateEvaluationEnabled = ko.observable(false);
    self.DefaultMatchCodeVisible = ko.observable(false);
    self.DefaultMatchCodeHeader = ko.observable("");
    self.Initialized = ko.observable(false);
    self.EvaluationCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.IsLoading = ko.observable(false);
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.Sorting.subscribe(function () {
        self.Load();
    });

    self.PageIndex.subscribe(function () {
        self.Load();
    });

    self.PageSize.subscribe(function () {
        self.PageIndex(0);
        self.Load();
    });

    self.DisplayTotalRows = ko.computed(function () {
        return self.TotalRows();
    });

    self.FolderStructureChecklistId.subscribe(function (value) {
        Bao.post("Checkware/Module/GetEvaluationFilter", JSON.stringify({
            folderStructureChecklistId: value
        }), function (searchResult) {
            if (searchResult != null) {
                self.EvaluationFilters(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 1) {
                        self.EvaluationFilterId(parameter[1]);
                    }
                }
            }
            else {
                self.EvaluationFilters([]);
            }

            if (value == null || value == "00000000-0000-0000-0000-000000000000") {
                self.CreateEvaluationEnabled(false);
            }
            else {
                self.CreateEvaluationEnabled(true);
            }
        });
    });
    self.Load = function () {
        var def = $.Deferred();

        if (self.EvaluationFilterId() == null || self.EvaluationFilterId() == "00000000-0000-0000-0000-000000000000" || self.FolderStructureChecklistId() == null) {
            self.TotalRows(0);
            self.EvaluationCollection([]);
            def.resolve();
        }
        else {
            self.DefaultMatchCodeHeader("");
            self.DefaultMatchCodeVisible(false);
            self.IsLoading(true);
            Bao.post("Checkware/Module/GetEvaluations", JSON.stringify({
                folderStructureChecklistId: self.FolderStructureChecklistId(),
                evaluationFilterId: self.EvaluationFilterId(),
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.EvaluationCollection([]);
                if (searchResult != null && searchResult.Result != null) {
                    self.EvaluationCollection(searchResult.Result);
                    self.TotalRows(searchResult.TotalRows);
                    self.DefaultMatchCodeHeader(searchResult.MatchCodeHeader);
                    self.DefaultMatchCodeVisible(searchResult.MatchCodeVisible);
                }
                def.resolve();
                self.IsLoading(false);
            });
        }
        return def.promise();
    };
    self.EvaluationFilterId.subscribe(function () {
        if (self.PageIndex() != 0) {
            self.PageIndex(0);
        }
        else {
            self.Load();
        }
    });
    self.CreateEvaluation = function () {
        if (self.FolderStructureChecklistId() != null) {
            baoRouter.setHash("checkware/checklist/" + self.FolderStructureChecklistId());
        }
    };

    self.parent.Refresh = function () {
        return self.init().then(function () { return self.Load(); })
    };

    self.init = function () {
        var def = $.Deferred();
        $.when(Bao.post("Checkware/Checklist/GetChecklists", JSON.stringify({}), function (searchResult) {        
            if (searchResult != null) {
                self.Checklists(searchResult);
                if (self.parent != null && self.parent.Parameter() != null) {
                    var parameter = self.parent.Parameter().split(";");
                    if (parameter.length > 0) {
                        self.FolderStructureChecklistId(parameter[0]);
                    }
                }
                self.FolderStructureChecklistId.valueHasMutated();
            }
            else {
                self.Checklists([]);
            }
        })).then(function () {
            self.Initialized(true);
            def.resolve();
        });
        return def.promise();
    };
}
export default EvaluationFilterViewModel;